import { PaymentFields } from '../../../../../../../src/interfaces/WoocommercePaymentBlockSupport';

function Label( props ) {
    const { PaymentMethodLabel } = props.components;
    const settings: PaymentFields = props?.settings ?? {};
    let img = settings?.icon ? <img src={settings.icon}/> : props.label ?? '';
    return <PaymentMethodLabel text={img} />;
}
export default Label;
